// any polyfills go here
import promise from 'es6-promise';

promise.polyfill();



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/polyfill.js